import React from 'react';

type SocialIconProps = {
  icon: string;
  href: string;
  click: (icon: string, event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const SocialIcon: React.StatelessComponent<SocialIconProps> = (props) => {

  return (
    <a className="social-icon" href={props.href} onClick={e => props.click(props.icon, e)}>
      <i className={`icon icon-${props.icon}`}></i>
    </a>
  );
};
